<script>
export default {
  name: 'log',
  data() {
    return {
      username: localStorage.getItem('name'),
      loading: true,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      user: [],
      searchType: '',
      searchModule: '',
      searchPhone: '',
      typeOptions: [{value: "管理员", label: "管理员"}, {value: "用户", label: "用户"}],
      moduleOptions: [{
        value: '管理员',
        label: '管理员',
        children: [{value: '登录', label: '登录',}, {value: '用户管理', label: '用户管理',}, {
          value: '分类图片管理',
          label: '分类图片管理',
        }, {value: '图片管理', label: '图片管理'}, {value: '首页分类管理', label: '首页分类管理',}, {
          value: '促销管理',
          label: '促销管理',
        }, {value: '新品推荐管理', label: '新品推荐管理',}, {value: '管理员管理', label: '管理员管理',},]
      }, {
        value: '用户',
        label: '用户',
        children: [{value: '登录', label: '登录'}, {value: '查看', label: '查看'}, {value: '订单', label: '订单'}, {
          value: '更换设备',
          label: '更换设备',
        }]
      }]
    }
  },
  mounted() {
    this.getList()
    this.$axios.get("/admin/user/all").then((res) => {
      this.user = res.data.data
    })
    console.log(this.user)
  },
  methods: {
    // 获取数据
    getList() {
      this.loading = true
      this.$axios.get("/admin/log", {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          type: this.searchType,
          module: this.searchModule,
          phone: this.searchPhone,
        }
      }).then((res) => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
        this.loading = false
      })
    },    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    changeType() {
      this.currentPage = 1
      this.getList()
    },
    changeModule() {
      this.currentPage = 1
      this.searchModule = this.searchModule[this.searchModule.length - 1]
      this.getList()
    },
    search() {
      this.currentPage = 1
      this.getList()
    },
    searchClear() {
      this.currentPage = 1
      this.searchType = ""
      this.searchModule = ""
      this.searchPhone = ""
      this.getList()
    },
    out() {
      this.$router.push({name: 'login'})
    }
  }
}
</script>
<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>登录记录</el-breadcrumb-item>
        <div style="position: absolute; right: 100px;top: 20px;font-size: 15px">
          <div style="display:flex;align-items:center;">
            <el-avatar size="large" style="margin: 5px;"
                       src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            {{ username }}
            <el-button type="text" @click="out" style="margin: 5px;">退出登录</el-button>
          </div>
        </div>
      </el-breadcrumb>
      类型
      <el-select v-model="searchType" placeholder="请选择" @change="search">
        <el-option
          v-for="item in typeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      模块
      <el-cascader
        v-model="searchModule"
        :options="moduleOptions"
        :props="{ expandTrigger: 'hover' }"
        @change="changeModule"></el-cascader>
      账号
      <el-input class="topInput" placeholder="请输入要搜索的账号" prefix-icon="el-icon-search" v-model="searchPhone"
                clearable @keyup.enter.native="search"></el-input>
      <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="danger" plain icon="el-icon-delete" @click="searchClear">重置</el-button>
    </el-header>
    <el-main>
      <el-table
        v-loading="loading"
        style="width: 1200px;"
        :data="tableData"
        stripe
        border
        highlight-current-row
        current-row-key="id"
        max-height="700">
        <el-table-column label="序号" width="70" align="center">
          <template slot-scope="scope">
            {{ (scope.$index + 1) + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" align="center" width="100">
        </el-table-column>
        <el-table-column prop="module" label="模块" align="center" width="115">
        </el-table-column>
        <el-table-column prop="phone" label="账号" align="center" width="150">
        </el-table-column>
        <el-table-column prop="phone" label="姓名" align="center" width="150">
          <template slot-scope="scope" v-if="scope.row.type!=='管理员'">
            {{ user.find(key => key.phone === scope.row.phone).name }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="content" align="center" label="操作内容">
        </el-table-column>
        <el-table-column prop="gmtCreate" label="时间" width="200" align="center">
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :pager-count="11"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-footer>
  </div>
</template>
<style scoped>
.el-header {
  margin-top: 30px;
  margin-left: 25px;
}

.topInput {
  margin-top: 15px;
  margin-bottom: 30px;
  width: 200px;
}

.el-main {
  margin-top: 10px;
  margin-left: 25px;
}

.el-footer {
  text-align: center;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/logView.vue